function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == typeof i ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != typeof t || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != typeof i) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
import { Button } from '@rd-web-markets/shared/dist/util/buttons';
import React, { useState } from 'react';
import { Card, Row, Col } from 'react-bootstrap';
import { useTranslation } from 'react-i18next';
import { useHistory } from 'react-router-dom';
import elsterQuickUpdatesService from '../../services/company/elster_quick_updates.service';
import { useSelector } from 'react-redux';
const ManagementTab = _ref => {
  let {
    elster,
    setElster,
    fetchCompanyMenu,
    paramForCompanyMenuFetch
  } = _ref;
  const {
    t
  } = useTranslation();
  const history = useHistory();
  const [loading, setLoading] = useState(false);
  const accountType = useSelector(state => state.auth.user.account_type);
  const {
    quickUpdate,
    deleteElster
  } = elsterQuickUpdatesService.useCrud(elster.company_id, setElster, setLoading, async _ref2 => {
    let {
      pushToMasterPage
    } = _ref2;
    await fetchCompanyMenu(paramForCompanyMenuFetch);
    pushToMasterPage && history.push("/".concat(accountType, "/companies/").concat(elster.company_id, "/master"));
  });
  const toggleHidden = () => {
    quickUpdate(_objectSpread(_objectSpread({}, elster), {}, {
      hidden: !elster.hidden
    }));
  };
  return /*#__PURE__*/React.createElement(Card, {
    className: "mt-3"
  }, /*#__PURE__*/React.createElement(Card.Body, null, /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    onClick: () => deleteElster(elster),
    icon: "delete",
    variant: "danger",
    disabled: !elster['destroyable?'],
    loading: loading
  }, t('delete_this_elster')))), !elster['destroyable?'] && /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, {
    md: 6
  }, /*#__PURE__*/React.createElement("p", null, t('this_elster_not_destroyable_message')))), /*#__PURE__*/React.createElement(Row, {
    className: "mb-3"
  }, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement(Button, {
    onClick: toggleHidden,
    icon: elster.hidden ? 'visibility' : 'visibility_off',
    variant: "warning",
    loading: loading
  }, elster.hidden ? t('unhide_this_elster') : t('hide_this_elster')))), elster.hidden && /*#__PURE__*/React.createElement(Row, null, /*#__PURE__*/React.createElement(Col, null, /*#__PURE__*/React.createElement("p", null, t('this_elster_already_hidden_message'))))));
};
export default ManagementTab;